namespace $ {

	/** Optional synchronous instrumentation. Never replaces a task, argument or Promise. */
	export abstract class $shm_hitalama_wire_measure {
		static active?: $shm_hitalama_wire_measure
		private static installed = false

		/** Production hook, independent of the opt-in development diagnostics. */
		static install() {
			if( this.installed ) return
			this.installed = true
			const original = $mol_wire_fiber.prototype.fresh
			$mol_wire_fiber.prototype.fresh = function() {
				const measure = $shm_hitalama_wire_measure.active
				const cursor = ( this as any ).cursor
				if( !measure || cursor === $mol_wire_cursor.fresh || cursor === $mol_wire_cursor.final ) return original.call( this )
				const token = measure.enter( this )
				try { return original.call( this ) }
				finally { measure.leave( token, this ) }
			}
		}
		abstract enter( fiber: $mol_wire_fiber< any, any, any > ): unknown
		abstract leave( token: unknown, fiber: $mol_wire_fiber< any, any, any > ): void
	}
}
